
export const CartAction = {
    ADD_PRODUCT_TO_CART: 'ADD_PRODUCT_TO_CART',
    UPDATE_CART_ITEM_QUANTITY: 'UPDATE_CART_ITEM_QUANTITY',
    SET_CART_ITEMS: 'SET_CART_ITEMS',
    CLEAR_CART: 'CLEAR_CART',
    REMOVE_FROM_CART: 'REMOVE_FROM_CART'
};

export const WishlistAction = {
    ADD_PRODUCT_TO_WISHLIST: 'ADD_PRODUCT_TO_WISHLIST',
    SET_WISHLIST_ITEMS: 'SET_WISHLIST_ITEMS',
    CLEAR_WISHLIST: 'CLEAR_WISHLIST',
    REMOVE_FROM_WISHLIST: 'REMOVE_FROM_WISHLIST'
};

export const OrderAction = {
    GET_ORDERS: 'GET_ORDERS',
    CREATE_ORDERS: 'CREATE_ORDERS',
};

export const AuthAction = {
    LOGIN: 'LOGIN',
    REGISTER: 'REGISTER',
    IS_VALID_TOKEN: 'IS_VALID_TOKEN',
    SET_USER: 'SET_USER',
    LOGOUT: 'LOGOUT',

    IS_REGISTERING: 'IS_REGISTERING',
    IS_LOGGING_IN: 'IS_LOGGING_IN',
    IS_LOGGED_IN: 'IS_LOGGED_IN',
    REGISTER_SUCCESS: 'REGISTER_SUCCESS',
    REGISTER_FAILURE: 'REGISTER_FAILURE',
    LOGIN_SUCCESS: 'LOGIN_SUCCESS',
    LOGIN_FAILURE: 'LOGIN_FAILURE',
};

export const NotificationAction = {
    SET_IS_LOADING: 'SET_IS_LOADING',
    SET_ERROR: 'SET_ERROR',
    INVALID_TOKEN: 'INVALID_TOKEN',

    SHOW_TOAST_SUCCESS: 'SHOW_TOAST_SUCCESS',
    SHOW_TOAST_ERROR: 'SHOW_TOAST_ERROR',
    CLEAR_TOAST: 'CLEAR_TOAST',

    SHOW_ALERT_SUCCESS: 'SHOW_ALERT_SUCCESS',
    SHOW_DIALOG_ERROR: 'SHOW_DIALOG_ERROR',
    CLEAR_ALERT: 'CLEAR_ALERT'

};